<template>
  <div class="pg-layout-banner">
    <div class="pg-layout-banner__img" v-show="!shrink">
      <img
        class="pg-layout-banner__img-banner"
        :src="userState?.solution?.banner || bannerImgDefault"
      />
    </div>
    <div class="pg-layout-banner__text" v-show="!shrink && !headerCovered">{{ systemName }}</div>
    <img
      v-show="shrink && !headerCovered"
      class="pg-layout-banner__icon"
      :src="userState?.solution?.icon || bannerIconDefault"
    />
  </div>
</template>
<script setup>
import bannerImgDefault from '../../../static/image/logo-pangu-350x78.png'
import bannerIconDefault from '../../../static/image/logo.png'
import { USER_INJECTION_KEY } from '../../../tokens/index'
import { inject, computed, getCurrentInstance } from 'vue'

defineProps({
  //左侧是否收起
  shrink: Boolean,
  //顶部是否铺满
  headerCovered: Boolean,
})
const { proxy } = getCurrentInstance()
const { userState } = inject(USER_INJECTION_KEY)
const systemName = computed(() => proxy.$store.state.user.system?.title || proxy.GLOBAL.SYSTEMNAME)
</script>
<style lang="scss">
@import '../style/layout-baner.scss';
</style>
